// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TiGb","colBig":"styles_colBig__31Jjo","colSmall":"styles_colSmall__1V-S2"};